import { Control, FieldErrors, Controller } from "react-hook-form"
import { motion } from "framer-motion"
import { Mail } from "lucide-react"
import { QuoteFormData } from "@/lib/validations/quote-form"
import { FormFieldWrapper } from "./form-field-wrapper"

interface StepFinalDetailsProps {
  control: Control<QuoteFormData>
  errors: FieldErrors<QuoteFormData>
  formData: QuoteFormData
}

export function StepFinalDetails({ control, errors, formData }: StepFinalDetailsProps) {
  return (
    <motion.div
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.3 }}
      className="max-w-2xl mx-auto"
    >
      <FormFieldWrapper
        icon={Mail}
        iconColor="bg-gradient-to-br from-purple-500 to-purple-600"
        label="Additional Information"
        error={errors.message?.message}
        hoverBorderColor="group-hover:border-purple-500/30"
      >
        <Controller
          name="message"
          control={control}
          render={({ field }) => (
            <textarea
              {...field}
              placeholder="Tell us about any special requirements, fragile items, or additional services you need..."
              rows={4}
              className="w-full border-0 bg-transparent focus:ring-0 text-base resize-none placeholder:text-slate-400 outline-none"
            />
          )}
        />
      </FormFieldWrapper>

      <div className="mt-6 p-4 bg-gradient-to-r from-blue-50 to-orange-50 rounded-xl border border-blue-100">
        <h4 className="font-semibold text-foreground mb-3">Quote Summary:</h4>
        <div className="grid grid-cols-2 gap-4 text-sm">
          <div>
            <span className="text-muted-foreground">Route:</span>
            <span className="font-medium text-foreground ml-2">{formData.from} → {formData.to}</span>
          </div>
          <div>
            <span className="text-muted-foreground">Type:</span>
            <span className="font-medium text-foreground ml-2">{formData.moveType.toLocaleUpperCase()}</span>
          </div>
          <div>
            <span className="text-muted-foreground">Contact:</span>
            <span className="font-medium text-foreground ml-2">{formData.name}</span>
          </div>
          <div>
            <span className="text-muted-foreground">Phone:</span>
            <span className="font-medium text-foreground ml-2">{formData.phone}</span>
          </div>
        </div>
      </div>
    </motion.div>
  )
}
